// apps/client/src/game/interactions/pickUp.ts (M1-T13) — A picks up the nearest dropped item in front of you, within reach, or the one
// at your feet (on your tile) whichever way you face; at priority 50 it outranks the mayor's Remove (1).
import { tuning } from '@whiskerton/content';
import type { ItemId } from '@whiskerton/shared';
import type { Interaction } from '../interact';
import { itemsLayerOf } from '../../world/items';

export const interaction: Interaction = {
  id: 'pickUp',
  find(ctx) {
    if (ctx.space !== 'out') return null;
    const layer = itemsLayerOf(ctx.game);
    if (!layer) return null;
    const fx = Math.sin(ctx.f), fy = Math.cos(ctx.f);
    let best: { id: string; d: number; x: number; y: number } | null = null;
    for (const i of layer.items()) {
      if (i.at.loc !== 'outdoors' || i.at.placed) continue;
      const x = i.at.x + 0.5, y = i.at.y + 0.5, dx = x - ctx.pos.x, dy = y - ctx.pos.y, d = Math.hypot(dx, dy);
      const atFeet = Math.floor(ctx.pos.x) === i.at.x && Math.floor(ctx.pos.y) === i.at.y;
      if (d > tuning.town.interactRange || (!atFeet && d > 0.6 && (dx * fx + dy * fy) / d < 0.2)) continue;
      if (!best || d < best.d) best = { id: i.id, d, x, y };
    }
    return best && { id: best.id, at: { x: best.x, y: best.y }, verb: 'hud.verbPickUp', priority: 50 };
  },
  run(ctx, c) { void ctx.game.cmd.pickUp(c.id as ItemId); },
  fromTap(ctx, hit) {
    if (ctx.space !== 'out') return null;
    // The game fills hit.object only; the dropped item on the tapped tile comes from the items layer.
    const item = hit.item ?? itemsLayerOf(ctx.game)?.items().find((i) => i.at.loc === 'outdoors' && !i.at.placed && i.at.x === hit.tile.x && i.at.y === hit.tile.y);
    return item && item.at.loc === 'outdoors' && !item.at.placed
      ? { id: item.id, at: { x: item.at.x + 0.5, y: item.at.y + 0.5 }, verb: 'hud.verbPickUp', priority: 50 } : null;
  },
};
